import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  VARIATIONS as moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

const BASE_CLASS = 'mt-NotificationsVehicleReservation'

const NotificationsVehicleReservation = ({onClose = () => {}, title = '', description = ''}) => {
  return (
    <div className={BASE_CLASS}>
      <MoleculeNotification
        alignItems={!title ? moleculeNotificationAlignItems.CENTER : undefined}
        autoClose={moleculeNotificationAutoClose.manual}
        icon={<IconInfoOutline size={atomIconSizes.medium} />}
        onClose={onClose}
        roundedCorners={moleculeNotificationBorderSizes.medium}
        show
        showCloseButton
        type={moleculeNotificationTypes.info}
        variation={moleculeNotificationVariations.positive}
      >
        <div className={`${BASE_CLASS}-content`}>
          {title && <span className={`${BASE_CLASS}-title`}>{title}</span>}
          <span>{description}</span>
        </div>
      </MoleculeNotification>
    </div>
  )
}

NotificationsVehicleReservation.displayName = 'NotificationsVehicleReservation'
NotificationsVehicleReservation.propTypes = {
  description: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string
}

export default NotificationsVehicleReservation
